import React from 'react';
import { cn } from '../cn';
import { InfoTooltip } from './InfoTooltip';
/** Flat card shell for dashboard charts. */
export const ChartCard = ({ title, tooltip, aside, loading, empty, emptyLabel = 'No activity in this period', className, children, }) => (React.createElement("div", { className: cn('flex flex-col rounded-2xl border border-gray-200 bg-white p-4', className) },
    React.createElement("div", { className: "mb-3 flex items-center justify-between gap-2" },
        React.createElement("div", { className: "flex items-center gap-1.5" },
            React.createElement("h3", { className: "text-sm font-semibold text-gray-800" }, title),
            tooltip ? React.createElement(InfoTooltip, { title: title, content: tooltip }) : null),
        aside),
    loading ? (React.createElement("div", { className: "flex h-48 items-center justify-center text-sm text-gray-400" }, "Loading\u2026")) : empty ? (React.createElement("div", { className: "flex h-48 items-center justify-center text-sm text-gray-400" }, emptyLabel)) : (children)));
export default ChartCard;
